<!--
  name : 김혜진
  desc : 가입한 사용자 레이아웃폼
  date : 2020-10-05
-->
<template>
  <v-app id="bgSt">
    <v-header></v-header>
    <router-view></router-view>
    <s-footer></s-footer>
  </v-app>
</template>
<script>
import VHeader from '@/views/layout/components/voucherHeader'
import SFooter from '@/views/layout/components/footer'

export default {
  name: 'memberLayout',
  components: {
    VHeader,
    SFooter
  },
  filters: {
  },
  data () {
    return {}
  },
  computed: {
    responsive: {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>